export default defineNuxtPlugin(() => {
  const app = useNuxtApp()
  const localePath = useLocalePath()

  app.vueApp.config.globalProperties.$localePath = localePath
})
